import { useEffect, useMemo, useState } from 'react'
import { executeInlinePollAction } from '../utils/api.js'
import { closeMiniApp, getStartParamToken, hapticNotification, showAlert } from '../utils/telegram.js'

const AUTO_CLOSE_DELAY_MS = 800

export default function InlinePollActionPage() {
  const token = useMemo(() => getStartParamToken(), [])
  const [state, setState] = useState({ loading: true, text: 'Creating poll…', success: false })

  useEffect(() => {
    let alive = true

    const run = async () => {
      if (!token) {
        if (!alive) return
        setState({ loading: false, text: 'Missing poll action token', success: false })
        return
      }

      try {
        const response = await executeInlinePollAction(token)
        if (!alive) return

        const message = response?.data?.message || 'Poll created'
        setState({ loading: false, text: message, success: true })
        hapticNotification('success')
        setTimeout(() => closeMiniApp(), AUTO_CLOSE_DELAY_MS)
      } catch (err) {
        if (!alive) return
        const message = err?.response?.data?.error || 'Could not create poll'
        setState({ loading: false, text: message, success: false })
        showAlert(message)
      }
    }

    run()
    return () => {
      alive = false
    }
  }, [token])

  return (
    <div className="status-message page-content">
      {state.loading && <div className="loading-spinner" />}
      <p style={{ marginTop: 12 }}>{state.text}</p>
    </div>
  )
}
